/***
 * 创建人：但志强
 * 时间：2019-5-27
 * 描述：角色管理的维护用户模态框
 * 更新说明:
 */
import { Component, OnInit, ViewChild, Output, EventEmitter, ElementRef, Renderer2, Input } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { environment } from 'src/environments/environment';
import { BdpService } from 'src/app/areas/bdp/bdp.service';
import { SwJwtService } from "src/app/librarys/serves/sw-jwt.service";
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
declare var $: any;

@Component({
  selector: 'sw-dynamic-form-link-user',
  templateUrl: './sw-dynamic-form-link-user.component.html',
  styleUrls: ['./sw-dynamic-form-link-user.component.css']
})
export class SwDynamicFormLinkUserComponent implements OnInit {

  
  /**
   * 动态创建组件传入的参数, 要含有 userId 这个数组,比如： {userId:ids,type:1,required:1,headerLogo:"审批人区域"}
   */
  @Input() param 

  /**
   * 动态创建组件的抛出事件
   */
  @Output() callback = new EventEmitter(); 

  /**
   * 模态框
   * @ignore
   */
  @ViewChild('userModal') userModal: SwModalframeComponent; 

  /**
   * 选中的用户
   * @ignore
   */
  selectedUsers:any[] =[] 

  /**
   * 所有的用户
   * @ignore
   */
  allUsers:any[] =[] 

  /**
   * 要回显的勾选的用户id数组
   * @ignore
   */
  checkedUser:any[] = []

  /**
   * 左侧的筛选条件,可以使组织,岗位或角色
   * @ignore
   */
  filter:string = "" 

  /**
   * 树列表
   * @ignore
   */
  tree:any[] = [] 

  /**
   * 树组件是否支持底层节点带复选框的功能，一开始不支持
   * @ignore
   */
  selectChildren:boolean = false

  /**
   * 树组件上面的搜索内容
   * @ignore
   */
  searchValue:string = ""

  /**
   * 面包屑数据
   * @ignore
   */
  crumbs:any[] = []

  /**
   * 模态框标题，默认是 "审批人区域"
   * @ignore
   */
  headerLogo:string = "通讯录"

  /**
   * 模态框选值是否是必填项，默认是2-->必填项，不选择用户点击确定会提示，如果是1-->不是必填，那么不选用户也可以点击确定
   * @ignore
   */
  required:number = 2

  /**
   * 搜索结果
   * @ignore
   */
  searchList:any[] = []

  /**
   * 组件类型，1：根据角色，岗位，组织查询用户 ； 2：直接显示所有用户，不需查询， 默认为1
   * @ignore
   */
  type:number = 1

  constructor(
    private systemId:SystemIdService,
    private bdpService: BdpService, //请求服务
    private el:ElementRef,
    private renderer2:Renderer2,
    private http: SwHttpClientService, //http请求
    private box: SwMassageBoxService,  //消息提示服务
    ) { }

  ngOnInit() {
    this.selectChildren = false
    // 看是否有回显的id
    if(this.param.userId){
      this.checkedUser = JSON.parse(JSON.stringify(this.param.userId))
    }
    // 看类型是否指定
    if(this.param.type){
      this.type = JSON.parse(JSON.stringify(this.param.type))
    }
    if(this.param.required){
      this.required = this.param.required
    }
    if(this.param.name){
      this.headerLogo = this.param.name
    }
    if(this.param.data){
      this.allUsers = this.param.data
    }
    // //获取所有用户
    this.getUser()
  }

  //首次获取所有用户 
  getUser(){
    //获取用户
    var Check = $("input[name='user']");
    //然后全部取消选择
    Check.prop("checked", false)
    
    // 根据回显的 this.checkedUser id数组来确定 选中的用户
    this.allUsers.forEach(user=>{
      let checked = this.checkedUser.indexOf(user.id) != -1
      user.checked = checked
    })
    this.selectedUsers = this.allUsers.filter(v=>v.checked)
    if(this.type == 2){
      //如果直接显示所有用户，不需要根据角色岗位组织去查询
      this.tree = JSON.parse(JSON.stringify(this.allUsers))
      this.selectChildren = true  //底层节点多选
    } else {
      //根据角色岗位组织去查询
      this.tree = [{id:'1',text:'按角色选择',pid:'0'},{id:'2',text:'按组织选择',pid:'0'},{id:'3',text:'按岗位选择',pid:'0'}] 
    }
  }

  // 根据选中的id，刷新所有用户的选中状态，每次 this.checkedUser 有变化时，就顺便刷新这个
  refreshCheckedUsers(){
    this.allUsers.forEach(user=>{
      let checked = this.selectedUsers.findIndex(item => item.id == user.id) != -1
      user.checked = checked
    })
  }
  
  //改变复选框事件
  checKboxChange(event,data) {
    //判读是否选中
    if (event.target.checked) {
      // 将据的状态修改
      data.checked = true
      // 将之加到右侧已选中的数组中
      this.selectedUsers.push(data)
    } else {
      //如果是取消 则在选择数组中 删除掉数据
      let index2 = this.selectedUsers.findIndex(item => item.id == data.id)
      if( index2 != -1){  
        this.selectedUsers.splice(index2, 1);
      }
    }
    //刷新树的选中id
    this.checkedUser = this.selectedUsers.map(v=>v.id)
    // 刷新所有用户数组的选中状态
    this.refreshCheckedUsers()
  }

  // 点击全选框
  all(event){
    // 点击全选框，
    if (event.target.checked) {
      //如果是全选
      // 遍历此时的树，如果里面勾选的，在右侧有的就不管，没有就加到右侧
      this.tree.forEach(v=>{
        // 看右侧有没有该用户
        let index = this.selectedUsers.findIndex(item => item.id == v.id)
        if(index == -1){
          // 如果没有该用户，就加到右侧
          v.checked = true
          this.selectedUsers.push(v)
        }
      })
    } else {
      //如果是取消全选
      this.tree.forEach(v=>{
        // 如果该用户没有被选中
        // 看右侧有没有该用户
        let index = this.selectedUsers.findIndex(item => item.id == v.id)
        if(index != -1){
          // 如果有该用户，从中删除
          this.selectedUsers.splice(index,1)
        }
      })
    }
    //刷新树的选中id
    this.checkedUser = this.selectedUsers.map(v=>v.id)
    // 刷新所有用户数组的选中状态
    this.refreshCheckedUsers()
  }

  //获取左侧角色树
  getRole(){
    let param2 = {systemId: this.systemId.getSystemId()}
    this.bdpService.getRoleService().queryList(param2).subscribe(  //请求角色数据
      data => {
        if (data["code"] == 200) {
          let arr1 = [];
          //获取到的数组中没有id text pid字段,所以要处理一下数据,转化为树组件所需要的格式
          data["data"]["records"].forEach(e => {
            arr1.push({ id: e.roleId, text: e.roleName, pid: 'Yiji',isAdmin:e.isAdmin })
          });
          this.tree = arr1
        }
      }
    )
  }

  //获取左侧岗位树
  getPosition(){
    let param3 = {systemId: this.systemId.getSystemId() }
    this.bdpService.getPositionService().queryList(param3).subscribe(data => {
      if (data["code"] == 200) {
        //数组中自带了 id text pid字段,不需要处理
        this.tree = data["data"]["records"]
      }
    });
  }

  //获取左侧组织树
  getDepartment() {
    let systemId = this.systemId.getSystemId()//拿系统id
    let Params =  { systemId: systemId } //取所有组织管理数据
    this.bdpService.getDepartmentService().queryList(Params).subscribe(data => {
      if (data["code"] == 200) { //请求成功
        //数组中自带了 id text pid字段,不需要处理
        this.tree = data["data"]["records"];
      }
    });
  }

  // 树组件抛出
  onVoted(event){
    if(this.selectChildren == true){
      // 将此时的树的被选中的节点id放进一个数组中
      let users = event.map(node=>node.key)
      // 遍历此时的树，如果里面勾选的，在右侧有的就不管，没有就加到右侧
      this.tree.forEach(v=>{
        if(users.indexOf(v.id) != -1){
          //如果该节点被勾选
          // 看右侧有没有该用户
          let index = this.selectedUsers.findIndex(item => item.id == v.id)
          if(index == -1){
            // 如果没有该用户，就加到右侧
            v.checked = true
            this.selectedUsers.push(v)
          }
        } else {
          // 如果该用户没有被选中
          // 看右侧有没有该用户
          let index = this.selectedUsers.findIndex(item => item.id == v.id)
          if(index != -1){
            // 如果有该用户，从中删除
            this.selectedUsers.splice(index,1)
          }
        }
      })
      //最新的选中的用户
      // 刷新所有用户数组的选中状态
      this.refreshCheckedUsers()
    } else {
      if(event.key == '1'){
        //如果是按角色选择
        // 获取角色
        this.getRole()
        // 面包屑数据
        this.crumbs = [event]
        // 记录下是按什么选择，之后查询对应的用户接口
        this.filter = 'role'
      } else if(event.key == '2'){
        //如果是按组织选择
        // 获取组织
        this.getDepartment()
        // 面包屑数据
        this.crumbs = [event]
        this.filter = 'department'
      } else if(event.key == '3'){
        //如果是按岗位选择
        // 获取岗位
        this.getPosition()
        // 面包屑数据
        this.crumbs = [event]
        this.filter = 'position'
      } else{
        // 不是第一级了，而是点击了某个角色，岗位或组织，去查询对应的用户
        this.crumbs.push(event)
        if(this.crumbs[0].key == '1'){
          //点击了某个角色，重新查询用户，先要根据选中的用户数组，将选中的id数组更新
          this.checkedUser = this.selectedUsers.map(v=>v.id)
          this.onVotedRole(event)
        } else if(this.crumbs[0].key == '2'){
          //点击了某个组织，重新查询用户，先要根据选中的用户数组，将选中的id数组更新
          this.checkedUser = this.selectedUsers.map(v=>v.id)
          this.onVotedDepartment(event)
  
        } else if(this.crumbs[0].key == '3'){
          //点击了某个岗位，重新查询用户，先要根据选中的用户数组，将选中的id数组更新
          this.checkedUser = this.selectedUsers.map(v=>v.id)
          this.onVotedPosition(event)
  
        }
      }

    }
  }

  //面包屑抛出事件
  ovtedCrumbs(event){
    if(!event.selectData && !event.newCrumbs.length){
      //回到最初
      this.tree = [{id:'1',text:'按角色选择',pid:'0'},{id:'2',text:'按组织选择',pid:'0'},{id:'3',text:'按岗位选择',pid:'0'}]
      // 面包屑清空
      this.crumbs = event.newCrumbs
      // 树组件不复选
      this.selectChildren = false 
    } else if(event.newCrumbs.length == 1 && event.selectData.key == '1'){
      //如果面包屑只有一级，且点击的id是1,按角色选择，那就查询角色树
      this.getRole()
      // 面包屑清空
      this.crumbs = event.newCrumbs
      // 树组件不复选
      this.selectChildren = false
    } else if(event.newCrumbs.length == 1 && event.selectData.key == '2'){
      //如果面包屑只有一级，且点击的id是2,按组织选择，那就查询组织树
      this.getDepartment()
      // 面包屑清空
      this.crumbs = event.newCrumbs
      // 树组件不复选
      this.selectChildren = false
    } else if(event.newCrumbs.length == 1 && event.selectData.key == '3'){
      //如果面包屑只有一级，且点击的id是3,按岗位选择，那就查询岗位树
      this.getPosition()
      // 面包屑清空
      this.crumbs = event.newCrumbs
      // 树组件不复选
      this.selectChildren = false
    } else if(event.newCrumbs.length > 1 && event.newCrumbs[0].key == '1'){
      //如果面包屑只有一级，且点击的id是1,按角色选择，那就查询角色树
      this.onVotedRole(event.selectData)
      // 面包屑清空
      this.crumbs = event.newCrumbs
      // 树组件不复选
      this.selectChildren = false
    } else if(event.newCrumbs.length > 1 && event.newCrumbs[0].key == '2'){
      //如果面包屑只有一级，且点击的id是2,按组织选择，那就查询组织树
      this.onVotedDepartment(event.selectData)
      // 面包屑清空
      this.crumbs = event.newCrumbs
      // 树组件不复选
      this.selectChildren = false
    } else if(event.newCrumbs.length > 1 && event.newCrumbs[0].key == '3'){
      //如果面包屑只有一级，且点击的id是3,按岗位选择，那就查询岗位树
      this.onVotedPosition(event.selectData)
      // 面包屑清空
      this.crumbs = event.newCrumbs
      // 树组件不复选
      this.selectChildren = false
    }
  }

  //组织树的选中结果
  onVotedDepartment(event){
    //根据组织查询用户
    let param = { "param": { pageSize: 0,systemId:this.systemId.getSystemId() }, "organizeId": event.key,lazy:false, "entity":{} }
    this.bdpService.getCommonService().queryUserByOrganizeId(param).subscribe(data => {
      let temp = [];
      //获取数据 绑定 数据 
      if (data["code"] == 200) {
        let result = data["data"]["records"]
        result.forEach(user => {
          if(user.status){
            let checked = this.checkedUser.indexOf(user.userId) != -1
            temp.push({id:user.userId,text:user.displayName,pid:'999',checked:checked})
          }
        });
        // 将用户数据赋值给树
        this.tree = temp
        // 树组件变为底层节点可选
        this.selectChildren = true
        
      }
    })
  }

  //角色树的选中结果
  onVotedRole(event){
    //根据角色查询用户
    let param = { "param": { pageSize: 0 },  "entity": {"roleId": event.key,systemId:this.systemId.getSystemId()} }
    this.bdpService.getUserService().queryUserByRoleId(event.key,this.systemId.getSystemId()).subscribe(data => {
      let temp = [];
      //获取数据 绑定 数据 
      if (data["code"] == 200) {
        let result = data["data"]
        result.forEach(user => {
          if(user.status){
            let checked = this.checkedUser.indexOf(user.userId) != -1
            temp.push({id:user.userId,text:user.displayName,pid:'999',checked:checked})
          }
        });
        // 将用户数据赋值给树
        this.tree = temp
        // 树组件变为底层节点可选
        this.selectChildren = true
       
      }
    })
    
  }

  //岗位树的选中结果
  onVotedPosition(event){
    let param = { "param": { pageSize: 0,systemId:this.systemId.getSystemId() }, "positionId": event.key, "entity":{}}
    this.bdpService.getUserService().queryUserByPositionId(param).subscribe(data => {
      let temp = [];
      //获取数据 绑定 数据 
      if (data["code"] == 200) {
        let result = data["data"]["records"]
        result.forEach(user => {
          if(user.status){
            let checked = this.checkedUser.indexOf(user.userId) != -1
            temp.push({id:user.userId,text:user.displayName,pid:'999',checked:checked})
          }
        });
        // 将用户数据赋值给树
        this.tree = temp
        // 树组件变为底层节点可选
        this.selectChildren = true
       
      }
    })
    
  }

  //点击指定执行人模态框的确认按钮
  sureOperator(){
    this.checkedUser = this.selectedUsers.map(v=>v.id)
    if(this.required == 2){
      //如果是必填项
      if(this.checkedUser.length){
        let val = {code:true,data:{paramCode:this.param['code'],paramValue:this.checkedUser.join(",")}}
        this.userModal.toggle() //关闭模态框(要先关闭模态框再销毁组件)
        this.callback.emit(val)  //抛出选中的用户,销毁组件,执行回调,且回调的参数就是选中的用户
      }else {
        this.box.danger('请选择用户')
      }
    } else if(this.required == 1){
      let val = {code:true,data:{paramCode:this.param['code'],paramValue:this.checkedUser.join(",")}}
      this.userModal.toggle() //关闭模态框(要先关闭模态框再销毁组件)
      this.callback.emit(val)  //抛出选中的用户,销毁组件,执行回调,且回调的参数就是选中的用户
    }
  }

  //点击关闭模态框
  closeOperatorModal(){
    let val = {code:false,data:[]}
    this.userModal.toggle() //关闭模态框
    this.callback.emit(val)
    //this.callback.emit(false)  //抛出false, 只销毁组件,什么都不做
  }

  //enter事件
  keydown(event) {
    this.searchValue = event.target.value
    this.search()
  }
 
  //点击搜索
  search(){
    if(this.searchValue){  //为true的时候展示用户
      this.searchList = this.allUsers.filter(item=>item.text.indexOf(this.searchValue)>=0)
    } else{
      // 没有搜索内容
      this.searchList = []
    }
  }

  // 删除某个已选中的用户
  clearOneUser(data){
    // 删除某个已选中的用户
    let index = this.selectedUsers.findIndex(item => item.id == data.id)
    if(index != -1){
      // 如果有该用户，从中删除
      this.selectedUsers.splice(index,1)
      // 刷新选中的id
      this.checkedUser = this.selectedUsers.map(v=>v.id)
      // 刷新所有用户数组的选中状态
      this.refreshCheckedUsers()
    }
  }

  // 意见清空所有选中用户
  clearAll(){
    this.selectedUsers = []
    this.checkedUser = []
    // 刷新所有用户数组的选中状态
    this.refreshCheckedUsers()
  }
}
